
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'
import EpbCheckbox from '../../checkbox.component.vue'
import { useBulkActionToolbar } from './use-bulk-action-toolbar'

export default defineComponent({
  name: 'EpbBulkActionCheckbox',
  components: {
    EpbCheckbox,
  },
  props: {
    value: {
      type: Object as PropType<unknown>,
      required: true,
    },
    disabled: Boolean,
  },
  emits: {
    input: (value: boolean, item: unknown) => {},
  },
  setup(prop, { emit }) {
    const { isSelected, unSelectItem, selectItem } = useBulkActionToolbar()

    const isItemSelected = computed(() => isSelected(prop.value))

    const onChange = (value: boolean) => {
      if (value) {
        selectItem(prop.value)
      } else {
        unSelectItem(prop.value)
      }

      emit('input', value, prop.value)
    }

    return {
      baseClass: 'epb-bulk-action-checkbox',
      isItemSelected,
      onChange,
    }
  },
})
